// extracted by mini-css-extract-plugin
export default {"clientLogo":"Navbar_clientLogo__WlI5G"};